import React from 'react';
import {useNavigate} from 'react-router-dom';
import "../../../assets/css/adminPages/home/serviceCard.scss";

const ServiceCard = ({service, onDelete}) => {
    let navigate = useNavigate();
    const {id, name, imageBase64, imageTag} = service;


    const handleClick = (serviceID) => {
        navigate(`/admin/services/${serviceID}`, {state: {service}});
    }

    return (
        <div className="col-xl-3 col-lg-4 col-md-6">
            <div className="custom-service-card-new">
                <div className="custom-service-card-header">
                    <img src={`data:image/jpg;base64,${imageBase64}`} alt={imageTag}/>
                </div>
                <div className="custom-service-card-body">
                    <span className="service-name">{name}</span>
                </div>
               <div className='custom-service-card-footer'>
                   <div className="mt-3 d-flex justify-content-center">
                       <button onClick={() => onDelete(id)} type="button" className="delete-btn">Delete</button>
                       <button onClick={() => handleClick(id)} type="submit" className="save-btn ml-2">Update</button>
                   </div>
               </div>
            </div>
        </div>
    );
};

export default ServiceCard;
